module.exports = __webpack_public_path__ + "img/changelly.9f95539b.png";